export default function CommunitySection() {
  const socialLinks = [
    {
      name: 'TELEGRAM',
      icon: 'ri-telegram-line',
      action: 'JOIN NOW',
      href: 'https://t.me/valhalla'
    },
    {
      name: 'TWITTER',
      icon: 'ri-twitter-x-line',
      action: 'FOLLOW',
      href: 'https://x.com/DeAlfonso99331'
    },
    {
      name: 'DEXSCREENER',
      icon: 'ri-line-chart-line',
      action: 'VIEW CHART',
      href: 'https://dexscreener.com'
    },
    {
      name: 'PUMP.FUN',
      icon: 'ri-rocket-line',
      action: 'TRADE',
      href: 'https://pump.fun'
    },
    {
      name: 'DISCORD',
      icon: 'ri-discord-line',
      action: 'JOIN',
      href: 'https://discord.gg/valhalla'
    }
  ];

  return (
    <section className="relative py-32 bg-gradient-to-b from-[#0a1628] to-black overflow-hidden">
      {/* Mead hall background */}
      <div className="absolute inset-0 opacity-15">
        <img
          src="https://public.readdy.ai/ai/img_res/93b9bca478d59887482f6aed84618bd1.jpg"
          alt="Mead Hall"
          className="w-full h-full object-cover"
        />
      </div>

      {/* Floating shields */}
      <div className="absolute inset-0 pointer-events-none">
        <img
          src="https://readdy.ai/api/search-image?query=ornate%20viking%20shield%20round%20wooden%20metal%20boss%20norse%20symbols%20painted%20design%20isolated%20transparent%20background%20warrior%20equipment&width=400&height=400&seq=shield-001&orientation=squarish"
          alt="Shield"
          className="absolute top-20 left-10 w-48 h-48 object-contain opacity-25 animate-rotate-slow"
        />
        <img
          src="https://readdy.ai/api/search-image?query=ornate%20viking%20shield%20round%20wooden%20metal%20boss%20norse%20symbols%20painted%20design%20isolated%20transparent%20background%20warrior%20equipment&width=400&height=400&seq=shield-002&orientation=squarish"
          alt="Shield"
          className="absolute bottom-32 right-20 w-56 h-56 object-contain opacity-25 animate-rotate-slow-reverse"
        />
        <img
          src="https://readdy.ai/api/search-image?query=ornate%20viking%20shield%20round%20wooden%20metal%20boss%20norse%20symbols%20painted%20design%20isolated%20transparent%20background%20warrior%20equipment&width=400&height=400&seq=shield-003&orientation=squarish"
          alt="Shield"
          className="absolute top-1/2 right-10 w-40 h-40 object-contain opacity-25 animate-rotate-slow"
        />
      </div>

      <div className="relative z-10 max-w-7xl mx-auto px-6">
        {/* Header */}
        <div className="text-center mb-20">
          <h2 className="text-5xl lg:text-6xl font-bold text-white mb-6 drop-shadow-[0_0_20px_rgba(212,175,55,0.6)]" style={{ fontFamily: 'Cinzel, serif' }}>
            ONLY THE WORTHY MAY ENTER THE HALL
          </h2>
          <p className="text-[#d4af37] text-2xl" style={{ fontFamily: 'Cinzel, serif' }}>
            Join the Brotherhood
          </p>
        </div>

        {/* Social links grid */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-5 gap-8 lg:gap-12">
          {socialLinks.map((link, index) => (
            <a
              key={index}
              href={link.href}
              target="_blank"
              rel="noopener noreferrer"
              className="group relative"
              style={{
                clipPath: 'polygon(30% 0%, 70% 0%, 100% 30%, 100% 70%, 70% 100%, 30% 100%, 0% 70%, 0% 30%)'
              }}
            >
              <div className="relative bg-black border-3 border-[#d4af37] h-56 flex flex-col items-center justify-center gap-4 transition-all duration-300 group-hover:bg-[#d4af37] group-hover:border-black group-hover:scale-110 group-hover:rotate-[5deg] cursor-pointer"
                style={{
                  clipPath: 'polygon(30% 0%, 70% 0%, 100% 30%, 100% 70%, 70% 100%, 30% 100%, 0% 70%, 0% 30%)'
                }}
              >
                {/* Icon */}
                <div className="w-16 h-16 flex items-center justify-center">
                  <i className={`${link.icon} text-5xl text-white group-hover:text-black transition-colors duration-300`}></i>
                </div>

                {/* Platform name */}
                <h3 className="text-lg font-bold uppercase text-white group-hover:text-black transition-colors duration-300 text-center px-4">
                  {link.name}
                </h3>

                {/* Action text */}
                <p className="text-sm text-[#d4af37] group-hover:text-black transition-colors duration-300 uppercase tracking-wider">
                  {link.action}
                </p>
              </div>
            </a>
          ))}
        </div>

        {/* Bottom decoration */}
        <div className="flex justify-center items-center gap-6 mt-20 text-[#d4af37] text-3xl opacity-60">
          <span className="rotate-45">⚔️</span>
          <span className="rotate-45">⚔️</span>
          <span className="rotate-45">⚔️</span>
          <span className="rotate-45">⚔️</span>
          <span className="rotate-45">⚔️</span>
        </div>
      </div>
    </section>
  );
}
